import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import IconMixin from '@rogues/shared/mixins/props/icon';

@Component
/**
 * BackToTop Props
 */
export default class Props extends Mixins(IconMixin) {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Text to show in the Button
     */
    @Prop({ type: String }) text!: string;

    /**
     * Size of the Button
     */
    @Prop({ type: String, default: 'normal' }) size!: string;

    /**
     * Color of the Button
     */
    @Prop({ type: String, default: 'primary' }) color!: string;

    /**
     * Element to scroll to
     * Default is 'body'
     */
    @Prop({ type: String, default: 'body' }) scrollTo!: string;

    /**
     * Show button in the right side of page
     */
    @Prop({ type: Boolean }) right!: boolean;
}
